export type ChecklistItemId = 'stripe' | 'gig';

export interface ChecklistInputs {
  /** `undefined` while Stripe status is loading. */
  stripeReady?: boolean;
  /** `undefined` while the user's gigs are loading. */
  postedGig?: boolean;
}

export interface ChecklistItemState {
  id: ChecklistItemId;
  done: boolean;
  /** True while the data needed to tell is still loading. */
  pending: boolean;
}

export const CHECKLIST_ORDER: ChecklistItemId[] = ['stripe', 'gig'];

/** The checklist only appears on My Gigs. */
export const CHECKLIST_ROUTES = ['/profile/my-gigs'];

export function buildChecklist(inputs: ChecklistInputs): ChecklistItemState[] {
  const state: Record<ChecklistItemId, { done: boolean; pending: boolean }> = {
    stripe: { done: !!inputs.stripeReady, pending: inputs.stripeReady === undefined },
    gig: { done: !!inputs.postedGig, pending: inputs.postedGig === undefined },
  };
  return CHECKLIST_ORDER.map((id) => ({ id, ...state[id] }));
}

export function checklistProgress(items: ChecklistItemState[]) {
  const done = items.filter((item) => item.done).length;
  return {
    done,
    total: items.length,
    complete: done === items.length,
    /** Ready to judge once nothing that is still undone is loading. */
    settled: items.every((item) => item.done || !item.pending),
  };
}
